import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-400 transition-colors cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 剧照`}
          title={`${movie.title} - 欲望之岛影视推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex gap-1">
          {movie.hot && (
            <span className="px-2 py-0.5 rounded bg-secondary-500 text-primary-950 text-[11px] font-label font-semibold">
              热播
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2 px-1.5 py-0.5 rounded bg-primary-950/80 text-accent-400 text-[11px] font-label font-semibold">
          {movie.rating.toFixed(1)}
        </div>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-primary-950/80 to-transparent"></div>
        <span className="absolute bottom-2 left-2 text-[11px] font-label text-background-200">
          {movie.region} · {movie.year}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-heading font-semibold text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
          {movie.synopsis}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] font-label"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}